import PropTypes from 'prop-types';
import React from 'react';
import { navigate } from 'gatsby-plugin-intl';

import Config from '../../config';
import injectUser from './injectUser';

const withAuthorization = (condition) => (Component) => {
  const WithAuthorization = (props) => {
    const { authUser, isAuthReady, pageContext } = props;

    if (!isAuthReady) {
      return null;
    }

    console.log('WithAuthorization : authUser', authUser);

    if (!authUser) {
      navigate(Config.routePaths.signin);
      return null;
    }

    if (
      pageContext.route
      && (pageContext.route === Config.routePaths.classLesson || pageContext.route === Config.routePaths.classProgram)
      && authUser.classes
      && authUser.classes.available
      && authUser.classes.available.indexOf(pageContext.classSlug) === -1
      && (!authUser.isFullPassActive)
    ) {
      navigate(`${Config.routePaths.classes}/${pageContext.classSlug}`, { replace: true });
      return null;
    }

    if (condition && !condition(authUser)) {
      navigate(Config.routePaths.landingPage);
      return null;
    }

    return (
      <Component {...props} />
    );
  };

  WithAuthorization.propTypes = {
    authUser: PropTypes.object,
    isAuthReady: PropTypes.bool,
    pageContext: PropTypes.object,
  };

  WithAuthorization.defaultProps = {
    authUser: null,
    isAuthReady: false,
    pageContext: {},
  };

  return injectUser(
    WithAuthorization,
  );
};

export default withAuthorization;
